import React from 'react';
import { FadeIn } from './FadeIn';
import { AlertCircleIcon, BatteryWarningIcon, TrendingDownIcon, ScissorsIcon } from 'lucide-react';
export function Problem() {
  const pains = [{
    icon: <BatteryWarningIcon className="w-7 h-7 text-brand-terracotta" data-id="element-186" />,
    title: 'Materiales acumulados, proyectos inconclusos',
    desc: 'Comprás papel, stickers y herramientas con entusiasmo. Empezás todo. No terminás nada. El cajón crece. La frustración también.'
  }, {
    icon: <ScissorsIcon className="w-7 h-7 text-brand-rose" data-id="element-187" />,
    title: 'Aprendés mucho, pero todo disperso',
    desc: 'Tutoriales sueltos en YouTube, grupos de Facebook, cursos a medias. Sabés cosas pero no tenés un sistema que conecte todo.'
  }, {
    icon: <AlertCircleIcon className="w-7 h-7 text-brand-gold" data-id="element-188" />,
    title: 'Papeles que se ondulan, tapas que se curvan',
    desc: 'El adhesivo equivocado, el gramaje que no correspondía, la tapa que quedó horrible. No es falta de talento: es falta de base técnica.'
  }, {
    icon: <TrendingDownIcon className="w-7 h-7 text-brand-sage" data-id="element-189" />,
    title: 'Regalás tiempo, técnica y creatividad',
    desc: 'No sabés cuánto cobrar, cómo fotografiar, cómo presentar. Vendés barato o directamente regalás lo que hiciste. Y duele.'
  }];
  return <section id="problema" className="py-16 sm:py-24 px-5 bg-brand-dark relative overflow-hidden" data-id="element-190">
      {/* Dark section for contrast */}
      <div className="absolute inset-0 bg-brand-ink pointer-events-none" data-id="element-191" />
      <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-brand-gold/5 blur-[100px] rounded-full pointer-events-none" data-id="element-192" />

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-193">
        <FadeIn data-id="element-194">
          <div className="max-w-3xl mb-12 sm:mb-16" data-id="element-195">
            <span className="inline-block text-brand-gold font-bold tracking-widest text-xs uppercase mb-4 border border-brand-gold/30 px-3 py-1 rounded-full" data-id="element-196">
              La realidad que nadie dice en voz alta
            </span>
            <h3 className="text-3xl sm:text-5xl font-black text-white leading-tight mt-4" data-id="element-197">
              Tenés la creatividad.
              <br data-id="element-198" />
              <span className="text-brand-gold" data-id="element-199">Te falta el sistema.</span>
            </h3>
            <p className="mt-6 text-lg text-white/60 leading-relaxed" data-id="element-200">
              Millones de crafteras en Latinoamérica tienen el mismo problema.
              No es falta de talento ni de materiales. Es que nunca tuvieron
              acceso a un recorrido completo, ordenado y en español.
            </p>
          </div>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5" data-id="element-201">
          {pains.map((pain, i) => <FadeIn key={i} delay={i * 0.1} data-id="element-202">
              <div className="bg-white/5 backdrop-blur-sm p-6 sm:p-7 border border-white/10 hover:border-brand-gold/40 transition-all group rounded-2xl h-full" data-id="element-203">
                <div className="mb-5 bg-white/10 w-14 h-14 flex items-center justify-center rounded-xl border border-white/10 group-hover:scale-110 transition-transform" data-id="element-204">
                  {pain.icon}
                </div>
                <h4 className="text-xl font-bold text-white mb-3" data-id="element-205">
                  {pain.title}
                </h4>
                <p className="text-white/60 leading-relaxed text-sm" data-id="element-206">
                  {pain.desc}
                </p>
              </div>
            </FadeIn>)}
        </div>

        {/* Bridge to solution */}
        <FadeIn delay={0.4} className="mt-12 sm:mt-16 text-center" data-id="element-207">
          <div className="inline-block bg-brand-gold/10 border border-brand-gold/30 rounded-2xl px-6 sm:px-8 py-6 max-w-2xl" data-id="element-208">
            <p className="text-white text-lg sm:text-xl font-semibold leading-relaxed" data-id="element-209">
              El Gran Tesoro del Craft existe para darte{' '}
              <span className="text-brand-gold" data-id="element-210">
                exactamente ese recorrido.
              </span>{' '}
              De principiante a profesional. De tutorial disperso a sistema
              completo.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}